<template>
  <div>
    <div class="page-header panel">
      <h3 class="title">
        Төлбөрийн хэрэгсэл
      </h3>
    </div>
    <el-row :gutter="0">
      <el-col :span="16" :offset="4">
        <div class="panel payments-container">
          <el-table :data="Payments" style="width: 100%">
            <el-table-column prop="image_url" label="Зураг" width="100px">
              <template slot-scope="scope">
                <img :src="scope.row.image_url" alt="" class="icon-image" />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="Нэр"> </el-table-column>
            <el-table-column prop="is_active" label="Төлөв" width="100px">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_active"
                  :disabled="!mArrayIncludes(role, ['ST', 'ops', 'TL', 'CC'])"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="is_selected"
              label="Default pay"
              width="150px"
              align="center"
            >
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.is_selected"
                  :disabled="!mArrayIncludes(role, ['ST', 'ops', 'TL', 'CC'])"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="Эрэмбэ" width="150px">
              <template>
                <el-button type="default" size="mini"
                  ><i class="el-icon-caret-top"></i
                ></el-button>
                <el-button type="default" size="mini"
                  ><i class="el-icon-caret-bottom"></i
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getGroups } from "../utils/auth";
import { arrayIncludes } from "../helpers/helper";
export default {
  mounted() {
    getGroups().then(data => {
      this.role = data;
    });
  },
  methods: {
    mArrayIncludes(base_array, searchArray) {
      return arrayIncludes(base_array, searchArray);
    }
  },
  data() {
    return {
      Payments: [
        {
          name: "Qpay",
          is_active: true,
          sort: 0,
          is_selected: true,
          image_url:
            "https://www.skytel.mn/uploads/news/ce44e9c201c705243db9e21fb2156ccf00db8234.png"
        },
        {
          name: "Khan Bank",
          is_active: true,
          sort: 1,
          is_selected: false,
          image_url:
            "data:image/png;base64,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"
        },
        {
          name: "Бэлэн",
          is_active: true,
          sort: 2,
          is_selected: false,
          image_url:
            "https://library.kissclipart.com/20191004/ow/kissclipart-cash-money-currency-dollar-saving-f95eef4dfcc3c2cb.png"
        },
        {
          name: "Карт уншуулах",
          is_active: true,
          sort: 3,
          is_selected: false,
          image_url:
            "https://cards.golomtbank.com/uploads/productGroupImages/5/15111440417.jpg"
        },
        {
          name: "Дансаар шилжүүлэх",
          is_active: false,
          sort: 4,
          is_selected: false,
          image_url:
            "https://virtualiban.net/wp-content/uploads/sites/31/2019/03/Virtual-IBAn-1-1024x1024.png"
        }
      ],
      role: []
    };
  }
};
</script>
